import { render, staticRenderFns } from "./RdDepotSwitcher.vue?vue&type=template&id=69a2a06e&scoped=true&"
import script from "./RdDepotSwitcher.vue?vue&type=script&lang=ts&"
export * from "./RdDepotSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a2a06e",
  null
  
)

export default component.exports